import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./planDetailSummary.module.scss";
import { Check } from "@untitled-ui/icons-react";
import classNames from "classnames";

const Title = (props: PropsWithChildren): ReactElement => {
  return <dt className={styles.title}>{props.children}</dt>;
};

const ItemList = (props: PropsWithChildren): ReactElement => {
  return <dl className={styles.list}>{props.children}</dl>;
};

const Item = (
  props: PropsWithChildren<{ inactive?: boolean }>,
): ReactElement => {
  return (
    <dd
      className={classNames(styles.listItem, {
        [styles.inactive]: props.inactive,
      })}
    >
      <Check data-role="check" />
      {props.children}
    </dd>
  );
};

export const PlanDetailSummary = {
  Title,
  ItemList,
  Item,
};
